













































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';

@Component({
  components: {
    BulkSearchModal,
  },
})
export default class TariffList extends Vue {
  /** 自定义字段查询内容 */
  private docValue: string = '';
  /** 列表数据 */
  private dataList: TypeTariffData.MergeListItem[] = [];
  /** 列表加载状态 */
  private loadingStatus: boolean = false;
  /** 全选状态 */
  private isCheckedAll: boolean = false;
  /** 全选按钮的中间态 */
  private indeterminate: boolean = false;
  /** 表格列 */
  private columns: TypeBase.TableColumn[] = [];
  /** 清关国（取自国家列表数据） */
  private countryList: TypeCommon.CountryList = [];
  /** 仓库列表 */
  private warehouseList: TypeCommon.AllWarehouseListItem[] = [];
  /** 单号类型 */
  @enumData('Finance/TariffCodeEnum')
  private codeTypeEnum: TypeBase.EnumListItem[] = [];
  /** 运输方式 */
  @enumData('Finance/TransportationMethodEnum')
  private TransportationMethodEnum: TypeBase.EnumListItem[] = [];
  // 列表勾选
  private rowSelection: TypeTariffData.rowSelection = {};
  /** 选中的项 */
  private selectedList: string[] = [];
  /** 搜索表单 */
  private searchData: TypeTariffData.SearchData = this.getInitSearchData();
  /** 上一次请求参数 */
  private lastParams: TypeTariffData.SearchData = {};
  /** 页码总数 */
  private total: number | null = 0;
  /** 选中数量 */
  private checkedNum: number = 0;
  /** 获取初始搜索 */
  @userPrefPageSize('tariffList')
  private getInitSearchData(): TypeTariffData.SearchData {
    return {
      page_index: 1,
      page_size: 10,
      /** 查询字段  */
      code_type: this.$enum.finance.TaiffCodeFieldEnum.TARIFF_BILL_NO,
      /** 查询值  */
      code_value_list: [],
      /** 运输方式  */
      transportation_method: undefined,
      /** 清关国 */
      clearance_country: undefined,
      /** 目的仓  */
      warehouse_code: undefined,
    };
  }
  /**
   * 合并行的方法
   */
  private customRender = (isCopy?: boolean) => {
    const h = this.$createElement;
    return (text: string | number, row: TypeTariffData.ListItem, index: number) => {
      const activeText = text || '--';
      return {
        children: isCopy ? <span v-copy2={text}>{activeText}</span> : activeText,
        attrs: { rowSpan: row._rowspan || 0 },
      };
    };
  }
  /**
   * 合并行的方法
   */
  private customWarehouseRender = (isCopy?: boolean) => {
    const h = this.$createElement;
    return (text: string | number, row: TypeTariffData.ListItem, index: number) => {
      const activeText = text ? text + `[${row.warehouse_name}]` : '--';
      return {
        children: <span >{activeText}</span>,
        attrs: { rowSpan: row._rowspan || 0 },
      };
    };
  }
  private customAttachmentRender = () => {
    const h = this.$createElement;
    return (text: string | number, record: TypeTariffData.ListItem, index: number) => {
      return {
        children: !record.file_info_resp_list ? <span >--</span> : <div>
          {record.file_info_resp_list.map((item, index) => {
            return <div class='file-box' key={index}>
              <span>{item.tariff_bill_file_name}{this.tc('：')}</span>
              <a class='ml-5 code-content'
                target='_blank'
                href={item.tariff_bill_file_path}>
                <a-icon class='ml-5'
                  type='download' />
              </a>
            </div>;
          })}
        </div>,
        attrs: { rowSpan: record._rowspan || 0 },
      };
    };
  }
  private createMergeTableList(list: TypeTariffData.ListItem[]) {
    const newList: TypeTariffData.MergeListItem[] = [];
    list.forEach((item) => {
      item.order_info_resp_list.forEach((child, index) => {
        newList.push({ ...item, ...child, _rowspan: item.order_info_resp_list && item.order_info_resp_list.length ? index === 0 ? item.order_info_resp_list.length : 0 : 1 });
      });
    });
    return newList;
  }
  /**
   * 明细列表
   */
  @loading('loadingStatus')
  private async queryTariffList(): Promise<void> {
    this.lastParams = this.$util.deepCopy(this.searchData);
    this.total = null;
    const { data } = await this.$api.finance.queryTariffData(this.searchData);
    const { list, total } = data;
    this.dataList = this.createMergeTableList(list);
    this.total = total;
  }
  /**
   * 获取国家列表
   */
  private async queryCountryList(): Promise<void> {
    const { data = [] } = await this.$api.common.queryCountryList<TypeCommon.CountryList>();
    this.countryList = data;
  }
  /**
   * 仓库列表
   */
  private async queryWarehouseList(): Promise<void> {
    const { data = [] } = await this.$api.common.queryAllWarehouseList();
    this.warehouseList = data;
  }
  private handleBulkFeedback(bulkKeywords: string): void {
    this.docValue = bulkKeywords;
  }
  /** 双击批量查询 */
  private handleDblClick(): void {
    const bulkSearchRef = this.$refs.bulkSearchModal as any;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.docValue;
  }
  /**
   * 页码变动
   */
  private handlePageChange(page: number): void {
    this.searchData.page_index = page;
    this.queryTariffList();
  }
  /**
   * 单号详情跳转
   */
  private handleJumpDetail(data: TypeTariffData.MergeListItem) {
    switch (data.order_type) {
      case this.$enum.finance.TariffOrderNoTypeEnum.BOOK_ORDER:
        this.$router.push({
          name: 'SlotBookingDetailsPage',
          query: {
            code: data.order_no,
          },
        });
        break;
      case this.$enum.finance.TariffOrderNoTypeEnum.FBA_ORDER:
        this.$router.push({
          name: 'LogisticsAgentDetailPage',
          query: {
            code: data.order_no,
          },
        });
        break;
      case this.$enum.finance.TariffOrderNoTypeEnum.INBOUND_ORDER:
        this.$router.push({
          name: 'InboundOrderDetailPage',
          query: {
            code: data.order_no,
          },
        });
        break;
    }

  }
  /** 全选，可优化 */
  private handleCheckAll(): void {
    const realList = this.dataList.filter((item) => item._rowspan);
    let everyChecked = realList.every((item) => item._checked);
    realList.forEach((item) => {
      this.$set(item, '_checked', !everyChecked);
    });
    const someChecked = realList.some((item) => item._checked);
    everyChecked = realList.every((item) => item._checked);
    this.indeterminate = someChecked && !everyChecked;
    this.isCheckedAll = everyChecked;
    this.selectedList = realList.filter((item) => item._checked).map((item) => item.tariff_bill_no);
    this.checkedNum = this.selectedList.length;

  }
  /** 单选 */
  private handleChangeOne(item: TypeTariffData.ListItem): void {
    this.$set(item, '_checked', !item._checked);
    const realList = this.dataList.filter((it) => it._rowspan);
    const someChecked = realList.some((it) => it._checked);
    const everyChecked = realList.every((it) => it._checked);
    this.indeterminate = someChecked && !everyChecked;
    this.isCheckedAll = everyChecked;
    this.selectedList = realList.filter((item) => item._checked).map((item) => item.tariff_bill_no);
    this.checkedNum = this.selectedList.length;
  }
  // 导出
  private async handleExport(isAll: boolean): Promise<void> {
    let postData: TypeTariffData.SearchData = {};
    if (isAll) {
      postData = { ...this.lastParams };
      delete postData.page_index;
      delete postData.page_size;
    } else {
      console.log(this.selectedList);
      if (!this.selectedList.length) {
        return this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
      }
      postData.code_type = this.$enum.finance.TaiffCodeFieldEnum.TARIFF_BILL_NO;
      postData.code_value_list = this.selectedList;
    }
    const { code, data, message } = await this.$api.finance.queryTariffDataExport<TypeBase.ExcelDataResult>(postData);
    if (code === 0) {
      this.$util.exportExcel(data);
    } else {
      this.$message.error(message);
    }
  }
  /**
   * 重置页面数据
   */
  private initPage(): void {
    this.searchData.page_index = 1;
  }
  /**
   * 搜索按钮
   */
  private handleSearch(): void {
    this.initPage();
    this.searchData.code_value_list = this.docValue ? this.docValue.split(',') : [];
    this.queryTariffList();
  }
  /**
   * 清空
   */
  private handleReset(): void {
    this.searchData = this.getInitSearchData();
    this.initPage();
    this.docValue = '';
    this.checkedNum = 0;
    this.$nextTick(() => this.queryTariffList());
  }
  private created(): void {
    const h = this.$createElement;
    this.columns = [
      {
        width: 50,
        title: () => {
          return (
            <div>
              <a-checkbox checked={this.isCheckedAll} indeterminate={this.indeterminate} onChange={this.handleCheckAll} />
            </div>
          );
        },
        customRender: (text: string | number, row: TypeTariffData.ListItem, index: number) => {
          return {
            children: <a-checkbox checked={row._checked} onChange={(e: Event) => this.handleChangeOne(row)} />,
            attrs: { rowSpan: row._rowspan || 0 },
          };
        },
      },
      {
        title: this.t('税单号'),
        dataIndex: 'tariff_bill_no',
        customRender: this.customRender(true),
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('业务单号'),
        dataIndex: 'order_no',
        scopedSlots: {
          customRender: 'order_no',
        },
        filterEmpty: true,
      },
      {
        title: this.t('单据类型'),
        dataIndex: 'order_type_text',
      },
      {
        title: this.t('跟踪号/海柜号'),
        dataIndex: 'sa_tank_no',
        filterEmpty: true,
        isCopy: true,
      },

      {
        title: this.t('计费时间'),
        dataIndex: 'confirm_time',
        customRender: this.customRender(),
      },
      {
        title: this.t('运输方式'),
        dataIndex: 'transportation_method_text',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: this.t('清关国'),
        dataIndex: 'clearance_country_name',
        align: 'right',
        customRender: this.customRender(),
      },
      {
        title: this.t('目的仓'),
        dataIndex: 'warehouse_code',
        width: 150,
        customRender: this.customWarehouseRender(),
      },
      {
        title: this.t('申报总价值'),
        dataIndex: 'declared_value',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: this.t('申报币种'),
        dataIndex: 'declared_currency',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: this.t('进口关税'),
        dataIndex: 'import_tariff',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: this.t('进口增值税'),
        dataIndex: 'import_added_tax',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: this.t('代垫关税手续费'),
        dataIndex: 'advance_payment_fee',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: this.t('税费总额'),
        dataIndex: 'tariff_total_amount',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: <div >
          <span>{this.t('单据税费金额')}</span>
          <a-tooltip>
            <template slot='title'>
              {this.t('若海运散货一个清关税号下存在多票入库单，关税总费用将均摊至各入库单。')}
            </template>
            <a-icon type='question-circle'
              class='ml-5' />
          </a-tooltip>
        </div>,
        dataIndex: 'bill_tariff_amount',
        filterEmpty: true,
      },
      {
        title: this.t('税费币种'),
        dataIndex: 'tariff_currency',
        filterEmpty: true,
        customRender: this.customRender(),
      },
      {
        title: this.t('附件'),
        dataIndex: 'file_info_resp_list',
        width: 200,
        customRender: this.customAttachmentRender(),
      },
    ];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: (selectedRowKeys: string[], selectedRows: TypeTariffData.ListItem[]): void => {
        this.rowSelection.selectedRowKeys = this.selectedList = selectedRowKeys;
      },
    };
    this.$nextTick(() => {
      this.queryTariffList();
    });
    this.queryCountryList();
    this.queryWarehouseList();
  }
}
